module.exports = __webpack_public_path__ + "img/Assari.4fa326bf.png";